(() => {
  const initialize = (root) => {
    if (!root || root.dataset.lefpReady === 'true') return;
    root.dataset.lefpReady = 'true';

    const comparison = root.querySelector('[data-lefp-comparison]');
    const range = root.querySelector('[data-lefp-range]');
    if (comparison && range) {
      const updateComparison = () => comparison.style.setProperty('--lefp-reveal', `${range.value}%`);
      range.addEventListener('input', updateComparison);
      range.addEventListener('change', updateComparison);
      updateComparison();
    }

    const productButtons = root.querySelectorAll('[data-lefp-product]');
    productButtons.forEach((button) => {
      const activate = () => {
        productButtons.forEach((item) => {
          const active = item === button;
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
          item.closest('.lefp-product-card')?.classList.toggle('is-active', active);
        });
      };
      button.addEventListener('click', activate);
      button.addEventListener('focus', activate);
      button.closest('.lefp-product-card')?.addEventListener('mouseenter', activate);
    });

    const scenarioTabs = root.querySelectorAll('[data-lefp-scenario]');
    const scenarioPanels = root.querySelectorAll('[data-lefp-scenario-panel]');
    scenarioTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.lefpScenario;
        scenarioTabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        scenarioPanels.forEach((panel) => {
          const active = panel.dataset.lefpScenarioPanel === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });

    const accessoryButtons = root.querySelectorAll('[data-lefp-accessory]');
    const accessoryImage = root.querySelector('[data-lefp-accessory-image]');
    const accessoryIndex = root.querySelector('[data-lefp-accessory-index]');
    const accessoryKind = root.querySelector('[data-lefp-accessory-kind]');
    const accessoryName = root.querySelector('[data-lefp-accessory-name]');
    const accessoryCopy = root.querySelector('[data-lefp-accessory-copy]');
    accessoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        accessoryButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (accessoryImage) {
          accessoryImage.src = button.dataset.image;
          accessoryImage.alt = button.dataset.name;
        }
        if (accessoryIndex) accessoryIndex.textContent = button.dataset.index;
        if (accessoryKind) accessoryKind.textContent = button.dataset.kind;
        if (accessoryName) accessoryName.textContent = button.dataset.name;
        if (accessoryCopy) accessoryCopy.textContent = button.dataset.copy;
      });
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-lest-editorial-home]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
